export const DEFAULT_PDF_COLOR = '#1D8773'

export const PRESET_COLORS: { label: string, value: string }[] = [
    { label: 'Vert (historique)', value: DEFAULT_PDF_COLOR },
    { label: 'Bleu marine', value: '#353756' },
    { label: 'Gris anthracite', value: '#37474F' },
    { label: 'Bordeaux', value: '#6E1423' },
    { label: 'Noir', value: '#1B1B1B' },
]

const HEX_COLOR_REGEX = /^#[0-9A-Fa-f]{6}$/

export function isValidHexColor(value: string | undefined): value is string {
    return !!value && HEX_COLOR_REGEX.test(value)
}

// Texte noir ou blanc selon la luminance YIQ du fond
export function computeTextColor(hexColor: string): string {
    const r = parseInt(hexColor.substring(1, 3), 16)
    const g = parseInt(hexColor.substring(3, 5), 16)
    const b = parseInt(hexColor.substring(5, 7), 16)
    const yiq = (r * 299 + g * 587 + b * 114) / 1000

    return yiq >= 128 ? '#000000' : '#FFFFFF'
}
